import { render, staticRenderFns } from "./ConfigClassTree.vue?vue&type=template&id=31c28abe&scoped=true"
import script from "./ConfigClassTree.vue?vue&type=script&lang=js"
export * from "./ConfigClassTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c28abe",
  null
  
)

export default component.exports